import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  // exportExcelReq,
  END_POINTS
} from '@/api'
// import * as dayjs from 'dayjs'
import * as Lodash from 'lodash'
import * as Constants from '@/constant'
import * as Utils from '@/utils'
import * as StoreUtils from '@/utils/StoreUtils'

// const baseUrl = process.env.BASE_URL

const SearchInfoBean = {
  rptId: '',
  compId: '',
  projId: '',
  rptStatus: '',
  END_SEARCH_INFO_BEAN: null
}

const InfoBean = {
  rptId: '',
  compId: '',
  projId: '',
  rptMth: '',
  rptStatus: '',
  firstSubmitDttm: null,
  lastSubmitDttm: null,
  lastRejectDttm: null,
  lastApprovalDttm: null,
  lastReopenDttm: null,
  remarks: '',
  crtBy: '',
  crtOn: null,
  updBy: '',
  updOn: null
}

const CheckStatusValueBean = {
  ACCOUNTANT_TRANS: false,
  SETTLE_INVOICE: false,
  FLOWTRANS_ACCOUNTANT: false,
  FLOWTRANS_CASHIER: false,
  SUMMARY: false,
  OP_STAT: false,
  FUND_STAT: false
}

const state = {
  searchInfo: { ...SearchInfoBean },
  searchedForm: { ...SearchInfoBean },
  list: [],
  info: {
    ...InfoBean
  },
  projMthRptMsgListObject: {
    projMthRptMsgList: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPage: 0
  },
  // editIndex: -1,
  // justUpdatedIndex: -1,
  // editAction: '',
  projMthRptDDList: [],
  editStatusValueMap: {},
  checkStatusValueMap: {},
  editStatusMap: {},
  checkStatusMap: {},
  END_STATE: null
}

const getters = {

}

const actions = {
  ...StoreUtils.actions,
  async insertProjMthRpt({
    dispatch,
    commit,
    state,
    rootState
  }, {key, codeParam}) { // projId, compId
    return new Promise(async (resolve, reject) => {
      const res = await postReq(END_POINTS.INSERT_PROJ_MTH_RPT, {
        data: {
          rptMth: Utils.formatDate(state.info.rptMth, Constants.YEAR_MONTH_FORMAT),
          remarks: state.info.remarks,
          //
          // rptId: rptId,
          projId: key.projId,
          compId: key.compId
        },
        headerMap: await getCPHeaderMap(key.compId, key.projId),
        headerCodeMap: await getHeaderCodeMap(codeParam)
      })
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  async updateProjMthRpt({
    dispatch,
    commit,
    state,
    rootState
  }, {key, codeParam}) { // rptId, projId, compId
    return new Promise(async (resolve, reject) => {
      const res = await putReq(END_POINTS.UPDATE_PROJ_MTH_RPT, {
        data: {
          remarks: state.info.remarks,
          //
          key
        },
        headerMap: getCPHeaderMap(key.compId, key.projId),
        headerCodeMap: getHeaderCodeMap(codeParam)
      })
      // debugger
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  async removeProjMthRpt({
    commit,
    state,
    rootState
  }, {key, codeParam}) { // rptId, projId, compId
    return new Promise(async (resolve, reject) => {
      const res = await deleteSendReq(END_POINTS.REMOVE_PROJ_MTH_RPT + `?rptId=${key.rptId}&projId=${key.projId}&compId=${key.compId}`, {
        headerMap: getCPHeaderMap(key.compId, key.projId),
        headerCodeMap: getHeaderCodeMap(codeParam)
      })
      // debugger
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  async findProjMthRptList({
    commit,
    state,
    rootState
  }, { currentPage, pageSize, codeParam }) {
    let searchedForm = state.searchedForm
    return new Promise(async (resolve, reject) => {
      const res = await getReq(END_POINTS.FIND_PROJ_MTH_RPT_LIST + `?projId=${searchedForm.projId}&compId=${searchedForm.compId}`, {
        headerMap: await getCPHeaderMap(searchedForm.compId, searchedForm.projId),
        headerCodeMap: await getHeaderCodeMap(codeParam)
      })
      // debugger
      if (res.success) {
        state.list = res.data
      }
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  async findProjMthRptDDList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    // let searchedForm = state.searchedForm
    return new Promise(async (resolve, reject) => {
      const res = await getReq(END_POINTS.FIND_PROJ_MTH_RPT_LIST + `?projId=${projId}&compId=${compId}`, {
        headerMap: await getCPHeaderMap(compId, projId),
        headerCodeMap: await getHeaderCodeMap(codeParam)
      })
      // debugger
      if (res.success) {
        state.projMthRptDDList = Lodash.map(res.data, function (item) {
          return { ...item, value: item.rptId, descr: item.rptMth }
        })
      }
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  // ...
  submitProjMthRpt({
    dispatch,
    commit,
    state,
    rootState
  }, {key, comment, codeParam}) { // rptId, projId, compId
    // debugger
    return new Promise(async (resolve, reject) => {
      const res = await putReq(END_POINTS.SUBMIT_PROJ_MTH_RPT, {
        data: {
          comment: comment,
          //
          key
        },
        headerMap: getCPHeaderMap(key.compId, key.projId),
        headerCodeMap: getHeaderCodeMap(codeParam)
      })
      // debugger
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  rejectProjMthRpt({
    dispatch,
    commit,
    state,
    rootState
  }, {key, comment, codeParam}) { // rptId, projId, compId
    // debugger
    return new Promise(async (resolve, reject) => {
      const res = await putReq(END_POINTS.REJECT_PROJ_MTH_RPT, {
        data: {
          comment: comment,
          //
          key
        },
        headerMap: getCPHeaderMap(key.compId, key.projId),
        headerCodeMap: getHeaderCodeMap(codeParam)
      })
      // debugger
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  approvalProjMthRpt({
    dispatch,
    commit,
    state,
    rootState
  }, {key, comment, codeParam}) { // rptId, projId, compId
    // debugger
    return new Promise(async (resolve, reject) => {
      const res = await putReq(END_POINTS.APPROVAL_PROJ_MTH_RPT, {
        data: {
          comment: comment,
          //
          key
        },
        headerMap: getCPHeaderMap(key.compId, key.projId),
        headerCodeMap: getHeaderCodeMap(codeParam)
      })
      // debugger
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  reopenProjMthRpt({
    dispatch,
    commit,
    state,
    rootState
  }, {key, comment, codeParam}) { // rptId, projId, compId
    // debugger
    return new Promise(async (resolve, reject) => {
      const res = await putReq(END_POINTS.REOPEN_PROJ_MTH_RPT, {
        data: {
          comment: comment,
          //
          key
        },
        headerMap: getCPHeaderMap(key.compId, key.projId),
        headerCodeMap: getHeaderCodeMap(codeParam)
      })
      // debugger
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  // ...
  async getProjMthRptCheckStatus({
    commit,
    state,
    rootState
  }, { rptId, projId, compId, codeParam }) {
    // let searchedForm = state.searchedForm
    return new Promise(async (resolve, reject) => {
      const res = await getReq(END_POINTS.GET_PROJ_MTH_RPT_CHECK_STATUS + `?rptId=${rptId}&projId=${projId}&compId=${compId}`, {
        headerMap: await getCPHeaderMap(compId, projId),
        headerCodeMap: await getHeaderCodeMap(codeParam)
      })
      // debugger
      if (res.success) {
        // debugger
        let editStatusValueMap = { ...CheckStatusValueBean }
        let checkStatusValueMap = { ...CheckStatusValueBean }
        state.editStatusMap = res.data.editStatusMap
        for (let key in state.editStatusMap) {
          editStatusValueMap[key] = state.editStatusMap[key].checkValue
        }
        state.editStatusValueMap = editStatusValueMap

        state.checkStatusMap = res.data.checkStatusMap
        for (let key in state.checkStatusMap) {
          checkStatusValueMap[key] = state.checkStatusMap[key].checkValue
        }
        state.checkStatusValueMap = checkStatusValueMap
      }
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  async updateProjMthRptCheckStatus({
    commit,
    state,
    rootState
  }, { checkGroup, checkType, checkValue, checkId, rptId, projId, compId, codeParam }) {
    // let searchedForm = state.searchedForm
    return new Promise(async (resolve, reject) => {
      const res = await putReq(END_POINTS.UPDATE_PROJ_MTH_RPT_CHECK_STATUS, {
        data: {
          rptId,
          checkGroup,
          checkType,
          checkValue,
          key: {
            checkId, projId, compId
          }
        },
        headerMap: await getCPHeaderMap(compId, projId),
        headerCodeMap: await getHeaderCodeMap(codeParam)
      })
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  async updateProjMthRptMsg({
    commit,
    state,
    rootState
  }, { msgId, rptId, projId, compId, remarks, codeParam }) {
    // let searchedForm = state.searchedForm
    return new Promise(async (resolve, reject) => {
      const res = await putReq(END_POINTS.UPDATE_PROJ_MTH_RPT_MSG, {
        data: {
          msgId,
          rptId,
          projId,
          compId,
          remarks,
          key: {
            msgId, projId, compId
          }
        },
        headerMap: await getCPHeaderMap(compId, projId),
        headerCodeMap: await getHeaderCodeMap(codeParam)
      })
      StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
    })
  },
  async findProjMthRptMsgCondition({
    commit,
    state,
    rootState
  }, { currentPage, pageSize, compId, projId, rptId, codeParam }) {
    let stateCurrentPage = currentPage
    if (pageSize) {
      state.projMthRptMsgListObject.pageSize = pageSize
      stateCurrentPage = 1
    }
    const projMthRptMsgListObject = await postReq(END_POINTS.FIND_PROJ_MTH_RPT_MSG_CONDITION, {
      data: {
        currentPage: stateCurrentPage,
        orderBy: '',
        pageSize: state.projMthRptMsgListObject.pageSize,
        queryVO: {
          compId: compId,
          projId: projId,
          rptId: rptId
        },
        refreshTotalRecord: true
      },
      headerMap: await getCPHeaderMap(compId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjMthRptMsgListObject', projMthRptMsgListObject)
  },
  END_ACTIONS() {}
}

const mutations = {
  ...StoreUtils.mutations,
  //
  updateProjMthRptMsgListObject(state, projMthRptMsgListObject) {
    if (projMthRptMsgListObject.code === 2001) {
      state.projMthRptMsgListObject.projMthRptMsgList = projMthRptMsgListObject.data
      state.projMthRptMsgListObject.currentPage = projMthRptMsgListObject.currentPage
      state.projMthRptMsgListObject.pageSize = projMthRptMsgListObject.pageSize
      state.projMthRptMsgListObject.total = projMthRptMsgListObject.total
      state.projMthRptMsgListObject.totalPage = projMthRptMsgListObject.totalPage
    } else {
      state.projMthRptMsgListObject.projMthRptMsgList = []
      state.projMthRptMsgListObject.total = 0
    }
  },
  resetSearchInfo(state) {
    state.searchInfo = { ...SearchInfoBean }
  },
  resetInfo(state) {
    state.info = { ...InfoBean }
  },
  updateList(state, list) {
    if (list.length) {
      state.list = list
      // state.list = []
    } else {
      state.list = []
    }
  },
  updateInfo(state, value) {
    // debugger
    state.info = {...value}
    state.info.firstSubmitDttm = new Date(value.firstSubmitDttm)
    state.info.lastSubmitDttm = new Date(value.lastSubmitDttm)
    state.info.lastRejectDttm = new Date(value.lastRejectDttm)
    state.info.lastApprovalDttm = new Date(value.lastApprovalDttm)
    state.info.lastReopenDttm = new Date(value.lastReopenDttm)
  },
  addListItem(state, { index }) {
    state.list.splice(index, 0, { ...InfoBean })
  },
  removeListItem(state, { index }) {
    state.list.splice(index, 1)
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/rpt/projMthRptManage.js